import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.VUE_APP_MIXPANEL_PROJECT, {secure_cookie: true});

export default mixpanel;
